import { formatEmotion, formatLanguage, getVoiceName, formatDuration } from "../../utils/voiceUtils";

function VoiceRecordItem({ voice, currentPlayingId, isPlaying, onPlayVoice, onCopy, onGenerateAvatar, hasApiKey }) {
    try {
        const handleGenerateAvatar = (e) => {
            e.preventDefault();
            e.stopPropagation();
                        
            if (!hasApiKey) {
                alert("請先設定 HeyGen API Key");
                return;
            }
            
            try {
                onGenerateAvatar(voice);
            } catch (error) {
                console.error("Error in avatar generation:", error);
                alert("生成數字人發生錯誤: " + (error.message || "未知錯誤"));
            }
        };

        return (
            <div 
                className="bg-white rounded-lg border border-gray-200 p-4 shadow-sm hover:shadow-md transition-shadow"
                data-name={`voice-record-${voice.id}`}
            >
                <div className="flex justify-between items-start mb-3">
                    <div>
                        <h3 className="font-medium text-lg">{getVoiceName(voice.voice_id)}</h3>
                        <div className="text-xs text-gray-500">
                            {new Date(voice.create_time).toLocaleString('zh-TW')}
                        </div>
                    </div>
                    <span className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full">
                        {formatLanguage(voice.language)}
                    </span>
                </div>
                
                <div className="text-sm text-gray-600 mb-3 line-clamp-2" title={voice.content}>
                    {voice.content}
                </div>
                
                <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-gray-500 mb-3">
                    { voice.extra_info?.audio_length && 
                    <div>
                        <span className="font-medium">時長:</span> {formatDuration(voice.extra_info?.audio_length)}
                    </div> }
                    <div>
                        <span className="font-medium">語速:</span> {voice.speed}x
                    </div>
                    <div>
                        <span className="font-medium">情緒:</span> {formatEmotion(voice.emotion)}
                    </div>
                </div>
                
                <div className="flex justify-between items-center mt-4">
                    <button
                        onClick={() => onPlayVoice(voice)}
                        className={`flex items-center justify-center w-10 h-10 rounded-full ${
                            currentPlayingId === voice.id && isPlaying
                                ? 'bg-red-500 hover:bg-red-600'
                                : 'bg-blue-500 hover:bg-blue-600'
                        } text-white transition-colors`}
                        data-name={`play-button-${voice.id}`}
                    >
                        <i className={`fas ${currentPlayingId === voice.id && isPlaying ? 'fa-pause' : 'fa-play'}`}></i>
                    </button>
                    
                    <div className="flex space-x-2">
                        <button
                            onClick={handleGenerateAvatar}
                            className={`px-3 py-1 ${
                                hasApiKey 
                                    ? 'bg-purple-500 hover:bg-purple-600' 
                                    : 'bg-gray-400 cursor-not-allowed'
                            } text-white rounded transition-colors flex items-center`}
                            disabled={!hasApiKey}
                            title={hasApiKey ? "生成數字人" : "請先設定 API Key"}
                            data-name={`generate-avatar-${voice.id}`}
                        >
                            <i className="fas fa-user-circle mr-1"></i>
                            生成數字人
                        </button>
                        <button
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                onCopy(voice.url);
                            }}
                            className="p-2 text-gray-600 hover:text-blue-600 transition-colors"
                            title="複製語音連結"
                            data-name={`copy-url-button-${voice.id}`}
                        >
                            <i className="fas fa-link"></i>
                        </button>
                        <button
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                onCopy(voice.content);
                            }}
                            className="p-2 text-gray-600 hover:text-blue-600 transition-colors"
                            title="複製原始文本"
                            data-name={`copy-text-button-${voice.id}`}
                        >
                            <i className="fas fa-copy"></i>
                        </button>
                    </div>
                </div>
            </div>
        );
    } catch (error) {
        console.error('VoiceRecordItem component error:', error);
        reportError(error);
        return null;
    }
}

export default VoiceRecordItem;